export enum CompareOrder {
	Before = -1,
	Equal = 0,
	After = 1,
}
